import { ErrorHandler, Injectable, inject } from '@angular/core';

import { LOCAL_STORAGE_KEY, StorageService } from './services';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private readonly storageService = inject(StorageService);

    handleError(error: unknown): void {
        const errorMessage = error instanceof Error ? error.message : undefined;
        const importModuleErrors: readonly string[] = [
            'Failed to fetch dynamically imported module',
            'Failed to load module script',
        ];

        if (
            error instanceof Error &&
            typeof errorMessage === 'string' &&
            importModuleErrors.some((err) => errorMessage.includes(err))
        ) {
            this.handleImportModuleError();
        } else {
            console.error('GlobalErrorHandler', error);
        }
    }

    private handleImportModuleError(): void {
        const lastRefreshTime: string | null = this.storageService.get(LOCAL_STORAGE_KEY.LAST_REFRESH_TIME);
        const expirationTime: number = 5 * 60 * 1000; // 5 minutes
        const now: number = new Date().getTime();
        const isTimePassed: boolean =
            lastRefreshTime && now - parseInt(lastRefreshTime) > expirationTime ? true : false;

        if (!lastRefreshTime || isTimePassed) {
            this.storageService.set(LOCAL_STORAGE_KEY.LAST_REFRESH_TIME, now.toString());
            setTimeout(() => {
                window.location.reload();
            });
        }
    }
}
